import React, { FC, useEffect, useState } from 'react';

interface Props {
  children: React.ReactNode;
  delay: number;
}

export const DebouncedComponent: FC<Props> = ({ children, delay }) => {
  const [debounced, setDebounced] = useState<Props['children'] | null>(null);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebounced(children);
    }, delay * 1000);

    return () => clearTimeout(timeout);
  }, [children, delay]);

  return <>{debounced}</>;
};
